<template>
  <div>
    <b-modal
      id="matterSimplifiedDestructionFormModal"
      ref="matterSimplifiedDestructionFormModal"
      centered
      size="lg"
      no-close-on-backdrop
      :title="$t('matter.matter_simplified_destruction')"
      :cancel-title="$t('others.cancel_title')"
      :ok-title="$t('others.ok_title')"
      cancel-variant="outline-secondary"
      @ok.prevent="addOrUpdate()"
      @close="clear()"
      @cancel="clear()"
    >
        <b-card>
            <b-row>
                 <b-col class="col-lg-6">
                    <b-form>
                        <label>{{ $t('matterSimplifiedDestruction.product_owner_destruction_request_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')"  size="sm" v-model="productOwnerDestructionRequestDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-6">
                    <b-form>
                        <label>{{ $t('matterSimplifiedDestruction.principal_destruction_request_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')"  size="sm" v-model="principalDestructionRequestDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                 <b-col class="col-lg-6">
                    <b-form>
                        <label>{{ $t('matterSimplifiedDestruction.destruction_order_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')"  size="sm" v-model="destructionOrderDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-6">
                    <b-form>
                        <label>{{ $t('matterSimplifiedDestruction.destruction_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')"  size="sm" v-model="destructionDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-6">
                    <b-form>
                        <label>{{ $t('matterSimplifiedDestruction.law_counter_party_disposal_company') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="lawCounterPartyDisposalCompanySelect" value-field="id" text-field="name" :options="lawCounterPartyDisposalCompanyOptions" />
                        </b-form-group>
                   </b-form>
                </b-col>
                <b-col class="col-lg-6">
                        <b-form>
                            <label>{{ $t('matter.process_result') }}</label>
                            <b-form-select size="sm" v-model="lawMatterProcessResultSelect" value-field="id" text-field="name" :options="lawMatterProcessResultOption" />
                        </b-form>
                </b-col>
            </b-row>
        </b-card>
     </b-modal>
  </div>
</template>

<script>

export default {
    props: {
        getMatterTypeHistoryList: {
            type: Function
        },
        employeeId: {
            type: Number
        }
    },
    data() {
        return {
            id: 0,
            lawMatterId: 0,
            productOwnerDestructionRequestDate: null,
            principalDestructionRequestDate: null,
            destructionOrderDate: null,
            destructionDate: null,
            lawCounterPartyDisposalCompanyOptions: [],
            lawCounterPartyDisposalCompanySelect: 0,
            lawMatterProcessResultOption: [],
            lawMatterProcessResultSelect: 0,
        }
    },
    methods:{
        clear(){
            this.lawCounterPartyDisposalCompanySelect = 0
        },
        async showSimplifiedDestruction(id, lawMatterId) {
            this.$refs['matterSimplifiedDestructionFormModal'].show()
            this.id = id
            this.lawMatterId = lawMatterId

            const data = {id: this.id }
            const controller = {name: 'LawMatterSimplifiedDestruction' }
            const payload = {data: data,controller: controller}
            const response = await this.$store.dispatch('moduleAuth/getInfo', payload);
            if (response.data.resultStatus == true){

                this.lawCounterPartyDisposalCompanyOptions = response.data.lawCounterPartyDisposalCompanyList
                this.lawCounterPartyDisposalCompanyOptions.splice(0, 0, this.$nullSelected())
                this.lawCounterPartyDisposalCompanySelect = response.data.lawMatterSimplifiedDestruction.lawCounterPartyDisposalCompanyId
                this.productOwnerDestructionRequestDate = response.data.lawMatterSimplifiedDestruction.productOwnerDestructionRequestDate
                this.principalDestructionRequestDate = response.data.lawMatterSimplifiedDestruction.principalDestructionRequestDate
                this.destructionOrderDate = response.data.lawMatterSimplifiedDestruction.destructionOrderDate
                this.destructionDate = response.data.lawMatterSimplifiedDestruction.destructionDate
                this.lawMatterProcessResultOption = response.data.lawMatterProcessResultList
                this.lawMatterProcessResultOption.splice(0, 0, this.$nullSelected())
                this.lawMatterProcessResultSelect = response.data.lawMatterInfo.lawMatterProcessResultId

            }else{
                this.$bvModal.hide('matterSimplifiedDestructionFormModal')
                    this.$WarningAlert(response.data.resultMessage)
            }
        },
         async addOrUpdate(){
            const lawMatterSimplifiedDestructionData =  {
                 id: this.id,
                 lawMatterId: this.lawMatterId,
                 destructionDate: this.destructionDate,
                 destructionOrderDate: this.destructionOrderDate,
                 lawCounterPartyDisposalCompanyId :this.lawCounterPartyDisposalCompanySelect,
                 principalDestructionRequestDate :this.principalDestructionRequestDate,
                 productOwnerDestructionRequestDate : this.productOwnerDestructionRequestDate,
                 lawMatterProcessResultId :this.lawMatterProcessResultSelect
            };
             const controller = { name: 'LawMatterSimplifiedDestruction' }  
             const payload = { data: lawMatterSimplifiedDestructionData, controller: controller}
             var response = await this.$store.dispatch('moduleAuth/save', payload)
             if (response.data.resultStatus == true) {
                if(!this.id){
                    this.id = response.data.id
                    await this.$SaveLawMatterMatterTypeHistory(9, this.id, this.lawMatterId,this.employeeId) 
                    this.getMatterTypeHistoryList()
                }
                this.$bvModal.hide('matterSimplifiedDestructionFormModal')
                this.$SaveAlert()
            } else {
                this.$WarningAlert(response.data.resultMessage)
            }  
        }
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>

